var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',{staticClass:"py-2"},[_c('div',{ref:"monacoContainer",staticClass:"editor rounded"})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }